export default function AnimationService() {

    // Config
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
    };

    const handleIntersect = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                // Optional: Unobserve after revealing if you want it to happen only once
                observer.unobserve(entry.target);

                // If it's a section, trigger children staggered reveal
                const children = entry.target.querySelectorAll('.reveal-child');
                children.forEach((child, index) => {
                    setTimeout(() => {
                        child.classList.add('is-visible');
                    }, index * 100); // Simple stagger
                });
            }
        });
    };

    return {
        init() {
            const observer = new IntersectionObserver(handleIntersect, observerOptions);

            // Observe text elements
            const revealElements = document.querySelectorAll(".reveal-text");
            revealElements.forEach(el => observer.observe(el));

            // Observe sections for child animations (if using that pattern)
            const sections = document.querySelectorAll("section");
            sections.forEach(section => {
               // Check if section has children that need revealing
               // Or simply observe the section to trigger something
               if(section.children.length > 0) {
                   // Add a utility class to children if they aren't already marked
                   Array.from(section.children).forEach(child => {
                       if(!child.classList.contains('reveal-text')) {
                            child.classList.add('reveal-child');
                       }
                   });
                   observer.observe(section);
               }
            });
        }
    };
}
